import type {AthleteChartEventsDomainModel} from "./athlete-chart-events.domain-model";
import {ChartEventsViewModel} from "../chart-events.view-model";
import {AthleteViewModel} from "../../../../common/athlete/athlete-view-model";
import {AthleteChartEventsAthleteViewModel} from "./athlete-chart-events.athlete.view-model";

export class AthleteChartEventsViewModel extends ChartEventsViewModel {
  mostCommonGoalZone: String;
  penaltyGoals: String;
  penaltyConversions: String;
  athlete: AthleteViewModel;

  constructor(model: AthleteChartEventsDomainModel) {
    super(model);

    this.mostCommonGoalZone = model.mostCommonGoalZone?.first();
    this.penaltyGoals = model.penaltyGoals;
    this.penaltyConversions = model.penaltyConversions;
    this.athlete = model.athlete ? new AthleteChartEventsAthleteViewModel(model.athlete) : null;
  }

  get penaltiesStats(): String {
    return `${this.penaltyConversions?.replace(/\s+/g, '')} (${this.penaltyGoals})`
  }

  get athleteId(): Number {
    return this.athlete.id;
  }

  get mainStats(): Map<String, String> {
    const mainStats = [];
    if (this.penaltiesStats) {
      mainStats.push({aliasName: "WEB_SHOT_MAP_OUTCOME_SITUATION", value: this.penaltiesStats})
    }
    if (this.mostCommonGoalZone) {
      mainStats.push({
        aliasName: "WEB_PENALTY_SHOTS_FAVORITE_GOAL_ZONE", value: this.mostCommonGoalZone
      })
    }

    return mainStats;
  }
}
